import type { ApiSingleResponse } from '@/types/api.config';
import type { AuthUser } from '@/types/user';
import { api } from './api.service';

export const authService = {
  async logout() {
    const response =
      await api.auth.post<ApiSingleResponse<void>>('/login/logout');
    return response;
  },

  async me() {
    const response = await api.auth.get<ApiSingleResponse<AuthUser>>(
      '/o1/me?orgName=contiple'
    );
    return response;
  },
};
